const SEARCH_COLLEGE_INDEX_TABLE_COLUMNS = [
  {
    title: "GPA requirement",
    key: "gpaRequired",
    dataIndex: "gpaRequired"
  },
  {
    title: "City",
    key: "city",
    dataIndex: "city"
  },
  {
    title: "State",
    key: "state",
    dataIndex: "state"
  },
  {
    title: "Division",
    key: "division",
    dataIndex: "division"
  }
];

const SEARCH_CLUB_EVENT_INDEX_TABLE_COLUMNS = [
  {
    title: "Date",
    dataIndex: "datetime"
  },
  {
    title: "Age Group",
    dataIndex: "ageGroup"
  },
  {
    title: "Location",
    dataIndex: "location"
  }
];

const CLUB_INDEX_TABLE_COLUMNS = [
  {
    title: "State",
    dataIndex: "stateName"
  },
  {
    title: "City",
    dataIndex: "city"
  },
  {
    title: "Age Group",
    dataIndex: "ageGroup"
  }
];

const ATHLETE_INDEX_TABLE_COLUMNS = [
  {
    title: "GPA",
    dataIndex: "gpa"
  },
  {
    title: "State",
    dataIndex: "state"
  },
  {
    title: "Graduation Year",
    dataIndex: "graduationYear"
  },
  {
    title: "Year Born",
    dataIndex: "birthYear"
  },
  {
    title: "Batting Hand/Average",
    dataIndex: "commonBattingInfo"
  },
  {
    title: "Throwing Hand",
    dataIndex: "throwingHand"
  }
];

const SEARCH_COLLEGE_EVENT_INDEX_TABLE = [
  {
    title: "Event Type",
    dataIndex: "eventType"
  },
  {
    title: "Date",
    dataIndex: "datetime"
  },
  {
    title: "Division",
    dataIndex: "division"
  },
  {
    title: "Location",
    dataIndex: "location"
  }
];

const COACH_INDEX_TABLE = [
  {
    title: "Coach",
    dataIndex: "name",
    width: 150
  },
  {
    title: "Position",
    dataIndex: "position",
    width: 100
  },
  {
    title: "Email",
    dataIndex: "email"
  },
  {
    title: "Phone Number",
    dataIndex: "staffPhone"
  }
];

const CLUB_COACH_INDEX_TABLE = [
  {
    title: "Coach",
    dataIndex: "name"
  },
  {
    title: "Position",
    dataIndex: "position"
  },
  {
    title: "Email",
    dataIndex: "email"
  },
  {
    title: "Phone Number",
    dataIndex: "staffPhone"
  }
];

const PAYMENT_HISTORY_COLUMNS = [
  {
    title: "Payment Date",
    dataIndex: "paymentDate"
  },
  {
    title: "Pricing Plan",
    dataIndex: "tablePricingPlan"
  },
  {
    title: "Amount",
    dataIndex: "tableAmount"
  },
  {
    title: "Expiration Date",
    dataIndex: "expirationDate"
  }
];

export {
  SEARCH_COLLEGE_INDEX_TABLE_COLUMNS,
  SEARCH_CLUB_EVENT_INDEX_TABLE_COLUMNS,
  CLUB_INDEX_TABLE_COLUMNS,
  ATHLETE_INDEX_TABLE_COLUMNS,
  SEARCH_COLLEGE_EVENT_INDEX_TABLE,
  COACH_INDEX_TABLE,
  CLUB_COACH_INDEX_TABLE,
  PAYMENT_HISTORY_COLUMNS
};
